var _defs, _image, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmileygreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smiley_green",
    "data-name": "smiley green",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.031,
    height: 22.031,
    viewBox: "0 0 22.031 22.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .greenSmiley {\r\n        fill: none;\r\n        stroke: #1fd76d;\r\n        stroke-width: 2.5px;\r\n      }\r\n    "))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Vector_Smart_Object",
    "data-name": "Vector Smart Object",
    x: 5.281,
    y: 5.281,
    width: 12,
    height: 13,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAAhElEQVQYlXXPsQkCQRCF4U8xMtHI1EIuF0wOwfAqMLCeQ0w9MTC3gqvBKmzASEbmcFF88GD+nTezu6Plfb/CDnO0eCQvgicJGx9FYDvgGNeief7iLjZ0CVMci+YMhwi8k0UjdCmvqHDCOqfCUcdZNTyySf8oNsTX/qmNQI8aNzzTUdfoX5FgFvQeHdOZAAAAAElFTkSuQmCC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "greenSmiley",
    cx: 11.015,
    cy: 11.016,
    r: 9.765
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileygreen);
export default __webpack_public_path__ + "static/media/smiley green.c3788618.svg";
export { ForwardRef as ReactComponent };